import { render, staticRenderFns } from "./StartDialog.vue?vue&type=template&id=4c9c4da1&scoped=true"
import script from "./StartDialog.vue?vue&type=script&lang=js"
export * from "./StartDialog.vue?vue&type=script&lang=js"
import style0 from "./StartDialog.vue?vue&type=style&index=0&id=4c9c4da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c4da1",
  null
  
)

export default component.exports